export default __webpack_public_path__ + "static/media/beforeOn.e642f270.svg";